//@ts-check
// 
import hash from "../../hash";
//
import { createApp } from "vue";

import b2bTypeahead from "../composant/b2bTypeahead";
import { toDate } from "../composant/b2bLangue";
import cardUsers from "../composant/cardUsers";

import { bootbox, ModalHelper } from "../../B2bTools"
// @ts-ignore
import html from "./groupDetail.html";
// @ts-ignore
import htmlDetailEdit from "./groupDetail@edit.html";

const js = ({
    url: function (echangeur) {
        echangeur.addAction('groupe.getDocById', echangeur.hash, 'form', 'group');
        echangeur.addAction('utilisateur.profilList', echangeur.hash, 'form', 'profils');
        echangeur.addAction('utilisateur.profilsEditables', echangeur.hash, 'form', 'profilsEditables');
    },
    onLoad: function (echangeur) {

        let THIS = this;

        let group = echangeur.group;
        let profils = echangeur.profils.rows;




        const app = createApp({
            components: {
                "type-ahead": b2bTypeahead,
                'card-users': cardUsers

            },
            data: () => ({
                group: {
                    v: group.v,
                    k: group.k,
                    rows: group.rows || [], // user k
                    memberUser: group.memberUser || [], // doc user
                    _id: group._id,
                    type: group.type,
                    dateCre: group.dateCre,
                },
                profils
            }),
            methods: {
                toProfil(k) {
                    let r = this.profils.find(el => (el.k == k));
                    return (r) ? r.v : k;
                },
                toDate: function (date) {
                    return toDate(date);
                },
                toUser(member) {
                    member.profilV = this.toProfil(member.profil);
                    return member;
                },
                async selectuser(item) {
                    let exists = this.group.memberUser.find(el => { return (el.k == item.k) })
                    if (!exists) {
                        let grp = await THIS.rest("groupe.addMember", { k: item.k, _id: this.group._id })
                        this.group.memberUser = grp.memberUser;
                    }
                },
                async remMember(user) {
                    let thisVue = this;
                    bootbox.confirm(
                        {
                            title: 'Remove user',
                            message: `Are you sure to remove <b> ${user.displayname} </b> from group ?`
                        },
                        async function () {
                            let grp = await THIS.rest("groupe.remMember", { k: user.k, _id: thisVue.group._id })
                            thisVue.group.memberUser = grp.memberUser;
                        })
                },
                typeaheaduser() {
                    return async function (key) {
                        let v = await THIS.rest("user.typeaheadInternal", { k: key, limit: 10 })
                        let retour = [];
                        v.forEach(element => {
                            retour.push({ k: element.k, v: element.displayname + " (" + element.email + ")" });
                        });
                        return retour;
                    }
                },
                groupEdit(group) {
                    let thisVue = this;

                    const modaleApp = createApp({
                        data: function () {
                            return {
                                saisie: {
                                    v: group.v,
                                    type: group.type,
                                    k: group.k
                                },
                                errors: {
                                    v: null,
                                    type: null,
                                    k: null,
                                    nb: 0
                                },
                                group
                            }
                        },
                        methods: {

                            close() {
                                ModalHelper.hide();
                            },


                            async valide() {
                                function nbe(objet) {
                                    let nb = 0;
                                    for (let key in objet) if (objet[key]) nb++;
                                    return nb;
                                }

                                this.errors = {};
                                if (this.saisie.type == "") { this.errors.type = true; }
                                if (this.saisie.v == "") { this.errors.v = true; }

                                this.errors.nb = nbe(this.errors);

                                if (this.errors.nb == 0) {

                                    let result = await THIS.rest("groupe.save", { _id: this.group._id }, this.saisie);
                                    if (!result.ok) {
                                        this.errors.message = result.errors;
                                    } else {
                                        ModalHelper.hide();
                                        thisVue.group.type = result.doc.type;
                                        thisVue.group.v = result.doc.v;
                                    }
                                }
                            },

                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    // @ts-ignore
                    modaleApp.mount(ModalHelper.html(htmlDetailEdit).container);

                },

                back() {
                    hash.fin();
                }
            },
        });

        app.mount(THIS.c$('._vueChargement')[0]);

    },

});

export default {
    groupDetail: { js: js, html: html }
};
